/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Signin_TimeoutInputs */

const en_login_error_signin_timeout = /** @type {(inputs: Login_Error_Signin_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in timed out. Please try again.`)
};

const fr_login_error_signin_timeout = /** @type {(inputs: Login_Error_Signin_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps de connexion écoulé. Veuillez réessayer.`)
};

const de_login_error_signin_timeout = /** @type {(inputs: Login_Error_Signin_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Anmeldung ist fehlgeschlagen. Bitte versuchen Sie es erneut.`)
};

const it_login_error_signin_timeout = /** @type {(inputs: Login_Error_Signin_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso scaduto. Riprova.`)
};

const ru_login_error_signin_timeout = /** @type {(inputs: Login_Error_Signin_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время ожидания входа истекло. Пожалуйста, попробуйте еще раз.`)
};

const es_login_error_signin_timeout = /** @type {(inputs: Login_Error_Signin_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se agotó el tiempo de inicio de sesión. Inténtalo de nuevo.`)
};

const zh_cn2_login_error_signin_timeout = /** @type {(inputs: Login_Error_Signin_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录超时，请重试。`)
};

const ja_login_error_signin_timeout = /** @type {(inputs: Login_Error_Signin_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインがタイムアウトしました。もう一度お試しください。`)
};

const hi_login_error_signin_timeout = /** @type {(inputs: Login_Error_Signin_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉग इन करने में समय समाप्त हो गया। कृपया पुनः प्रयास करें।`)
};

const pt_pt2_login_error_signin_timeout = /** @type {(inputs: Login_Error_Signin_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tempo limite de login expirou. Tente novamente.`)
};

/**
* | output |
* | --- |
* | "Sign-in timed out. Please try again." |
*
* @param {Login_Error_Signin_TimeoutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_signin_timeout = /** @type {((inputs?: Login_Error_Signin_TimeoutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Signin_TimeoutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_signin_timeout(inputs)
	if (locale === "de") return de_login_error_signin_timeout(inputs)
	if (locale === "it") return it_login_error_signin_timeout(inputs)
	if (locale === "ru") return ru_login_error_signin_timeout(inputs)
	if (locale === "es") return es_login_error_signin_timeout(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_signin_timeout(inputs)
	if (locale === "ja") return ja_login_error_signin_timeout(inputs)
	if (locale === "hi") return hi_login_error_signin_timeout(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_signin_timeout(inputs)
	return en_login_error_signin_timeout(inputs)
});